<template>
    <div class="customer-sap-pro-gp">
        <v-data-table
            hide-default-footer
            disable-pagination
            :headers="headers"
            :items="items"
            :no-data-text="error"
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td>{{ props.item.drerztext }}</td>
                    <td>{{ props.item.pvatext }}</td>
                    <td>{{ props.item.vbeln }}</td>
                    <td>{{ props.item.poarttext }}</td>
                    <td>{{ props.item.lieferbeginn | toDate }}</td>
                    <td>{{ props.item.lieferende | toDate }}</td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    name: 'SapProGp',
    props: [
        'purchase',
    ],
    data() {
        return {
            headers: [
                {
                    text: 'Druckerzeugnis',
                    align: 'left',
                    sortable: false,
                    value: 'drerztext',
                },
                {
                    text: '',
                    align: 'left',
                    value: 'pvatext',
                    sortable: false,
                },
                {
                    text: '',
                    align: 'left',
                    value: 'vbeln',
                    sortable: false,
                },
                {
                    text: '',
                    value: 'poarttext',
                    sortable: false,
                },
                {
                    text: 'gültig ab',
                    value: 'lieferbeginn',
                    sortable: false,
                },
                {
                    text: 'gültig bis',
                    value: 'lieferende',
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        items() {
            if (this.purchase.status === 'ok') {
                const d = this.purchase.data;
                const p = d['print-digital'] ? (d['print-digital'].ausgaben || []) : [];
                /* eslint-disable-next-line */
                return p.map(({ drerztext, pvatext, vbeln, poarttext, lieferbeginn, lieferende }) => ({
                    drerztext,
                    pvatext,
                    vbeln,
                    poarttext,
                    lieferbeginn,
                    lieferende,
                }));
            }
            return [];
        },
        error() {
            return this.purchase.status === 'ok' ? 'Keine Daten vorhanden' : 'Es ist ein Fehler bei der Datenübertragung aufgetreten';
        },
    },
};
</script>

<style scoped lang="scss"></style>
